import { render, staticRenderFns } from "./rp-roles-datasources.vue?vue&type=template&id=4d17ccde"
import script from "./rp-roles-datasources.vue?vue&type=script&lang=js"
export * from "./rp-roles-datasources.vue?vue&type=script&lang=js"
import style0 from "./rp-roles-datasources.vue?vue&type=style&index=0&id=4d17ccde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports